import * as React from 'react';
import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import Text16 from '@sdk/components/ui/typography/Text16';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

type PremiumPreviewRowProps = {
  reverse: boolean;
};
const PremiumPreviewRow = styled(Row)<PremiumPreviewRowProps>`
  flex: 1;
  flex-direction: ${({ reverse }): string => (reverse ? 'row-reverse' : 'row')};
  height: 246px;
  max-height: 246px;
  min-height: 246px;
  justify-content: space-between;
  align-items: center;
`;

const PreviewImageContainer = styled(Row)`
  flex: 0.4;
  justify-content: center;
  align-items: center;
`;

type PreviewImageProps = {
  width?: number;
};
// @TODO: interesting case: moving from angular to react I don't know why max-width is needed.
// How can we test that for regressions if we remove it?
const PreviewImage = styled.img<PreviewImageProps>`
  width: ${({ width }): string => (width ? width + 'px' : 'auto')};
  max-width: ${({ width }): string => (width ? width + 'px' : '100%')};
`;

const PreviewTextContent = styled(Column)`
  flex: 0.4;
  justify-content: center;
`;

type Props = {
  image: string;
  imageWidth?: number;
  title: string;
  description: string;
  reverse?: boolean;
};

export const PremiumFeaturePreviewRow: React.FC<React.PropsWithChildren<Props>> = ({
  image,
  imageWidth,
  title,
  description,
  reverse = false,
}) => (
  <PremiumPreviewRow reverse={reverse}>
    <PreviewImageContainer>
      <PreviewImage src={image} width={imageWidth} />
    </PreviewImageContainer>

    <PreviewTextContent>
      <Row pBottom={10}>
        <Text16 bold themeColor={ThemeColorType.gray}>
          {title}
        </Text16>
      </Row>
      <Row>
        <Text14 themeColor={ThemeColorType.gray}>{description}</Text14>
      </Row>
    </PreviewTextContent>
  </PremiumPreviewRow>
);
